import Icon from '../../../components/AppIcon';
import type { Metric } from '../types';

const MetricsSection = () => {
  const metrics: Metric[] = [
    {
      id: "1",
      value: "90%",
      label: "Response Time Reduction",
      icon: "Zap",
      description: "Average improvement in customer query response times"
    },
    {
      id: "2",
      value: "24/7",
      label: "Availability",
      icon: "Clock",
      description: "Round-the-clock customer support without additional staff"
    },
    {
      id: "3",
      value: "85%",
      label: "Query Resolution",
      icon: "CheckCircle2",
      description: "First-contact resolution rate for common inquiries"
    },
    {
      id: "4",
      value: "70%",
      label: "Cost Savings",
      icon: "TrendingDown",
      description: "Reduction in customer service operational costs"
    }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Proven Results That Matter
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Our AI chatbot solutions deliver measurable improvements across key business metrics
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics.map((metric) => (
            <div
              key={metric.id}
              className="bg-card rounded-xl p-6 border border-border hover:shadow-lg transition-shadow duration-fast"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name={metric.icon} size={24} className="text-primary" />
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="text-4xl font-bold text-primary">{metric.value}</div>
                <div className="text-lg font-semibold text-text-primary">{metric.label}</div>
                <p className="text-sm text-text-secondary">{metric.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;